// The backend has no server-side logout endpoint — JWTs are stateless.
// Logout is handled entirely on the client by clearing localStorage in the
// Navbar. This stub keeps the call site uniform with the { ok, status }
// shape every other API call returns.
export const logout = async () => ({ ok: true, status: 200, message: "Logged out", data: null });
